import { api } from "./api";

export interface ContactMessage {
  _id: string;
  name: string;
  email: string;
  subject: string;
  message: string;
  status: "pending" | "read" | "replied" | "archived";
  createdAt: string;
}

export const contactApi = {
  submitContact: (data: {
    name: string;
    email: string;
    subject: string;
    message: string;
  }) => {
    return api.post<{
      success: boolean;
      message: string;
      data: {
        id: string;
        status: string;
        createdAt: string;
      };
    }>("/contact", data);
  },
};